import * as _ from 'underscore';
import QRCode from 'qrcode';
import { View } from 'mappMvc/models/views';
import { ViewOptions } from 'mappMvc/interfaces';
import { ID } from 'mappMvc/const';
import { MetadataClient } from 'mappClient/metadataClient';
import { Templates } from '../../../compile';

export class MobileApp extends View {
	qrCode: KnockoutObservable<HTMLCanvasElement>;
	serverInfo: { name: string; title: string; baseUrl: string };

	constructor(options: ViewOptions) {
		super(
			_.defaults(options, <ViewOptions>{
				viewId: ID.Dynamic,
				template: Templates.mapps_mobileApp
			})
		);

		this.qrCode = ko.observable();
		this.qrCode.subscribe(this.qrCodeCallback);
	}

	public qrCodeCallback = (canvas: HTMLCanvasElement): void => {
		this.serverInfo = {
			name: MetadataClient.tenant,
			title: MetadataClient.tenant,
			baseUrl: window.location.href.split('#')[0].replace(/\/Apps\//ig, '/Mobile/')
        };

		QRCode.toCanvas(canvas, JSON.stringify(this.serverInfo), {
			width: 384,
			height: 384,
			color: {
				light: '#FFF'
			}
		});
	};
}
